@if (attachments.length > 0) {
  <div class="communication-alert-medias">
    @for (attachment of attachments; track attachment.id) {
      @if (attachment.kind === CommunicationMediaKind.Image || attachment.kind === CommunicationMediaKind.Video) {
        <button type="button" class="communication-alert-media"
          [attr.aria-label]="'communications.attachment.viewFullscreen' | translate: { fileName: attachment.fileName }"
          (click)="openFullscreen(attachment, $event)">
          @if (attachment.kind === CommunicationMediaKind.Image) {
            <img [src]="attachment.url" [alt]="attachment.fileName" />
          } @else {
            <video muted preload="metadata" [src]="attachment.url"></video>
          }
          <span class="communication-alert-media__expand" aria-hidden="true">
            <fa-icon [icon]="faExpand"></fa-icon>
          </span>
        </button>
      } @else {
        <a [href]="attachment.url" target="_blank" rel="noopener">{{ attachment.fileName }}</a>
      }
    }
  </div>
}

@if (selectedAttachment; as attachment) {
  <div class="communication-media-viewer" role="dialog" aria-modal="true"
    [attr.aria-label]="'communications.attachment.viewerAria' | translate: { fileName: attachment.fileName }"
    (click)="closeFullscreen()">
    <button type="button" class="communication-media-viewer__close"
      [attr.aria-label]="'communications.action.close' | translate" autofocus
      (click)="closeFullscreen()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
    <figure class="communication-media-viewer__content" (click)="$event.stopPropagation()">
      @if (attachment.kind === CommunicationMediaKind.Image) {
        <img [src]="attachment.url" [alt]="attachment.fileName" />
      } @else {
        <video controls autoplay [src]="attachment.url"></video>
      }
      <figcaption>{{ attachment.fileName }}</figcaption>
    </figure>
  </div>
}
